import React from "react";

type CellClampProps = {
  cell?: any;
  maxLines?: number;
  minChars?: number;
};

export function CellClamp({ cell, maxLines = 3, minChars = 120 }: CellClampProps) {
  if (!cell) return null;

  const row = cell.getRow?.();
  const field = cell.getField?.();

  const tableValue = cell.getValue?.();
  const dataVal = row?.getData?.()?.[field];
  const text = String(tableValue ?? dataVal ?? "");

  const data = row?.getData?.() ?? {};
  const expanded = Boolean(data._expanded?.[field]);

  const onToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (!row || !field) return;

    const current = Boolean(row.getData()._expanded?.[field]);
    const nextExpanded = { ...(row.getData()._expanded || {}), [field]: !current };

    row.update({ _expanded: nextExpanded }).then(() => {
      try { row.normalizeHeight(true); } catch {}
      try { cell.getTable().redraw(true); } catch {}
    });
  };

  return (
    <div style={{ whiteSpace: "normal" }}>
      <div
        className={expanded ? undefined : "clamp"}
        style={expanded ? undefined : { WebkitLineClamp: String(maxLines) }}
      >
        {text}
      </div>

      {text.length > (minChars ?? 120) && (
        <button type="button" className="tabulator-more-btn" onClick={onToggle}>
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
}
